


























import Vue from 'vue';
import Logo from './Logo.vue';

export default Vue.extend({
  components: {
    logo: Logo,
  },
});
